import { render, staticRenderFns } from "./TaskCardTypeBadge.vue?vue&type=template&id=2a433335&"
import script from "./TaskCardTypeBadge.vue?vue&type=script&lang=js&"
export * from "./TaskCardTypeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports